export const PERMISSIONS = {
    FILTER_PROVIDER: 'sport.filter.provider',
    AREA_THIRDPARTY:'sport.area.thirdparty',

    // COMPETITION
    SPORT_COMPETITION_HOME_PAGE: 'sport.competition.home.page',  
    SPORT_COMPETITION_CREATE_PAGE: 'sport.competition.create.page',
    SPORT_COMPETITION_EDIT_PAGE: 'sport.competition.edit.page',

    SPORT_COMPETITION_HOME_BUTTON_PROFILE: 'sport.competition.home.button.profile',

    SPORT_COMPETITION_HOME_BUTTON_CREATE: 'sport.competition.home.button.create',
    SPORT_COMPETITION_HOME_BUTTON_EDIT: 'sport.competition.home.button.edit',
    SPORT_COMPETITION_HOME_BUTTON_DELETE: 'sport.competition.home.button.delete',
    SPORT_COMPETITION_HOME_BUTTON_EXPORT: 'sport.competition.home.button.export',
    SPORT_COMPETITION_HOME_BUTTON_MULTIEDIT: 'sport.competition.home.button.multiedit',

    SPORT_COMPETITION_CREATE_AREA_VISIBLEAPI: 'sport.competition.create.area.visibleApi',
    SPORT_COMPETITION_CREATE_INPUT_NBDAYS: 'sport.competition.create.input.nbDays',
    SPORT_COMPETITION_CREATE_INPUT_NBTEAMS: 'sport.competition.create.input.nbTeams',
    SPORT_COMPETITION_CREATE_BUTTON_DELETE: 'sport.competition.create.button.delete',

    SPORT_COMPETITION_PROVIDER_NAME_DISPLAY: 'sport.competition.provider.name.display',

    // TEAM
    SPORT_TEAM_HOME_PAGE: 'sport.team.home.page',
    SPORT_TEAM_CREATE_PAGE: 'sport.team.create.page',
    SPORT_TEAM_EDIT_PAGE: 'sport.team.edit.page',
    SPORT_TEAM_MULTIEDIT_PAGE: 'sport.team.multiedit.page',

    SPORT_TEAM_HOME_BUTTON_CREATE: 'sport.team.home.button.create',
    SPORT_TEAM_HOME_BUTTON_EDIT: 'sport.team.home.button.edit',
    SPORT_TEAM_HOME_BUTTON_DELETE: 'sport.team.home.button.delete',
    SPORT_TEAM_HOME_BUTTON_EXPORT: 'sport.team.home.button.export',
    SPORT_TEAM_HOME_BUTTON_MULTIEDIT: 'sport.team.home.button.multiedit',
    SPORT_TEAM_HOME_BUTTON_EXPORTCSV: 'sport.team.home.button.exportcsv',
    SPORT_TEAM_HOME_BUTTON_PROFILE: 'sport.team.home.button.profile',

    SPORT_TEAM_CREATE_BUTTON_REMOVEPENALITY: 'sport.team.create.button.removePenality',
    SPORT_TEAM_CREATE_BUTTON_DIRECTTYPE: 'sport.team.create.button.directType',
    SPORT_TEAM_CREATE_BUTTON_DELETE: 'sport.team.create.button.delete',

    SPORT_TEAM_PROVIDER_NAME_DISPLAY: 'sport.team.provider.name.display',

    // PLAYER
    SPORT_PLAYER_HOME_PAGE: 'sport.player.home.page',
    SPORT_PLAYER_FUSION_PAGE: 'sport.player.fusion.page', 
    SPORT_PLAYER_CREATE_PAGE: 'sport.player.create.page',
    SPORT_PLAYER_EDIT_PAGE: 'sport.player.edit.page',
    SPORT_PLAYER_MULTIEDIT_PAGE: 'sport.player.multiedit.page',

    SPORT_PLAYER_HOME_BUTTON_CREATE: 'sport.player.home.button.create', 
    SPORT_PLAYER_HOME_BUTTON_EDIT: 'sport.player.home.button.edit',
    SPORT_PLAYER_HOME_BUTTON_DELETE: 'sport.player.home.button.delete',
    SPORT_PLAYER_HOME_BUTTON_EXPORT: 'sport.player.home.button.export',
    SPORT_PLAYER_HOME_BUTTON_MULTIEDIT: 'sport.player.home.button.multiedit',
    SPORT_PLAYER_HOME_BUTTON_EXPORTCSV: 'sport.player.home.button.exportcsv',
    SPORT_PLAYER_HOME_BUTTON_PROFILE: 'sport.player.home.button.profile',
    SPORT_PLAYER_HOME_BUTTON_FUSION: 'sport.player.home.button.fusion',

    SPORT_PLAYER_CREATE_BUTTON_REMOVETRANSFERT: 'sport.player.create.button.removeTransfert',
    SPORT_PLAYER_CREATE_BUTTON_DELETE: 'sport.player.create.button.delete',

    SPORT_PLAYER_PROVIDER_NAME_DISPLAY: 'sport.player.provider.name.display',

    // CALENDAR
    SPORT_CALENDAR_HOME_PAGE: 'sport.calendar.home.page',
    SPORT_CALENDAR_HOME_INPUT_DAY: 'sport.calendar.home.input.day',
    SPORT_CALENDAR_HOME_INPUT_DATE: 'sport.calendar.home.input.date',
    SPORT_CALENDAR_HOME_INPUT_TEAM: 'sport.calendar.home.input.team',
    SPORT_CALENDAR_HOME_EDIT_THIRDPARTY: 'sport.calendar.home.edit.thirdparty',
    SPORT_CALENDAR_HOME_BUTTON_EXPORTCSV: 'sport.calendar.home.button.exportcsv',

    // LIVES
    SPORT_LIVES_HOME_PAGE: 'sport.lives.home.page',
    SPORT_LIVES_HOME_BUTTON_CREATE: 'sport.lives.home.button.create',
    SPORT_LIVES_HOME_BUTTON_EDIT: 'sport.lives.home.button.edit',
    SPORT_LIVES_HOME_BUTTON_DELETE: 'sport.lives.home.button.delete',

    // ACTU LIVES
    DIVERS_LIVES_HOME_PAGE: 'divers.lives.home.page',
    DIVERS_LIVES_HOME_BUTTON_CREATE: 'divers.lives.home.button.create',
    DIVERS_LIVES_HOME_BUTTON_EDIT: 'divers.lives.home.button.edit',
    DIVERS_LIVES_HOME_BUTTON_DELETE: 'divers.lives.home.button.delete',
    DIVERS_LIVES_HOME_NAME_EDIT: 'divers.lives.home.name.edit',
    DIVERS_LIVES_HOME_DAYSTATS_DISPLAY: 'divers.lives.home.daystats.display',

    // LIVE
    SPORT_LIVE_HOME_PAGE: 'sport.live.home.page',
    

    // RESULT
    SPORT_RESULT_HOME_PAGE: 'sport.result.home.page',

    // MATCH
    SPORT_MATCH_HOME_PAGE: 'sport.match.home.page',

    // MATCH MANAGEMENT
    SPORT_MATCHMANAGEMENT_HOME_PAGE: 'sport.matchmanagement.home.page',

    // ADMIN
    SPORT_ADMIN_HOME_PAGE: 'sport.admin.home.page',
};